export default __webpack_public_path__ + "static/media/ast-1096619 2.66b75f4f.jpg";